import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import {
  BaseLeft,
  BaseRight,
  BaseTop,
  BasesContainer,
  BasesOutsContainer,
  Color,
  ColorsContainer,
  Container,
  Count,
  Inning,
  NumbersContainer,
  NumbersTopContainer,
  Out,
  Outs,
  Points,
  TeamContainer,
  TeamName,
  TeamsContainer,
} from './styles';

function BaseballSimple({ data, styles }) {
  const { awayTeam, balls, bases, homeTeam, inning, outs, strikes } = data;
  const { basesStyle, countStyle, inningStyle, points, teamName } = styles;

  return (
    <>
      <Helmet>
        <link
          href="https://fonts.googleapis.com/css2?family=Oswald&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      <Container>
        <TeamsContainer>
          <TeamContainer>
            <TeamName
              style={{
                background: teamName?.background,
                color: teamName?.color,
              }}
            >
              {homeTeam.name}
              <ColorsContainer>
                {homeTeam?.colors.map((color) => (
                  <Color key={color.id} style={{ background: color.value }} />
                ))}
              </ColorsContainer>
            </TeamName>
            <Points
              style={{
                background: points?.background,
                color: points?.color,
              }}
            >
              {homeTeam.points}
            </Points>
          </TeamContainer>
          <TeamContainer>
            <TeamName
              style={{
                background: teamName?.background,
                color: teamName?.color,
              }}
            >
              {awayTeam.name}
              <ColorsContainer>
                {awayTeam?.colors.map((color) => (
                  <Color key={color.id} style={{ background: color.value }} />
                ))}
              </ColorsContainer>
            </TeamName>
            <Points
              style={{
                background: points?.background,
                color: points?.color,
              }}
            >
              {awayTeam.points}
            </Points>
          </TeamContainer>
        </TeamsContainer>
        <NumbersContainer>
          <NumbersTopContainer>
            <Inning
              style={{
                background: inningStyle?.background,
                color: inningStyle?.color,
              }}
            >
              <ArrowDropUpIcon
                fontSize="medium"
                sx={{
                  color:
                    inning.half === 'top'
                      ? inningStyle?.active
                      : inningStyle?.inactive,
                }}
              />
              {inning.number}
              <ArrowDropDownIcon
                fontSize="medium"
                sx={{
                  color:
                    inning.half === 'bottom'
                      ? inningStyle?.active
                      : inningStyle?.inactive,
                }}
              />
            </Inning>
            <BasesOutsContainer
              style={{
                background: basesStyle?.background,
              }}
            >
              <BasesContainer>
                <BaseRight
                  style={{
                    backgroundColor: bases[0]
                      ? basesStyle?.active
                      : basesStyle?.inactive,
                  }}
                />
                <BaseTop
                  style={{
                    backgroundColor: bases[1]
                      ? basesStyle?.active
                      : basesStyle?.inactive,
                  }}
                />
                <BaseLeft
                  style={{
                    backgroundColor: bases[2]
                      ? basesStyle?.active
                      : basesStyle?.inactive,
                  }}
                />
              </BasesContainer>
              <Outs>
                <Out
                  style={{
                    backgroundColor:
                      outs >= 1 ? basesStyle?.active : basesStyle?.inactive,
                  }}
                />
                <Out
                  style={{
                    backgroundColor:
                      outs >= 2 ? basesStyle?.active : basesStyle?.inactive,
                  }}
                />
              </Outs>
            </BasesOutsContainer>
          </NumbersTopContainer>
          <Count
            style={{
              background: countStyle?.background,
              color: countStyle?.color,
            }}
          >
            {balls} - {strikes}
          </Count>
        </NumbersContainer>
      </Container>
    </>
  );
}

BaseballSimple.propTypes = {
  data: PropTypes.shape({
    homeTeam: PropTypes.shape({
      name: PropTypes.string,
      points: PropTypes.number,
    }),
    awayTeam: PropTypes.shape({
      name: PropTypes.string,
      points: PropTypes.number,
    }),
    inning: PropTypes.shape({
      number: PropTypes.number,
      half: PropTypes.string,
    }),
    balls: PropTypes.number,
    strikes: PropTypes.number,
    outs: PropTypes.number,
    bases: PropTypes.arrayOf(PropTypes.bool),
  }),
  styles: PropTypes.shape({
    points: PropTypes.shape({
      background: PropTypes.string,
      color: PropTypes.string,
    }),
    teamName: PropTypes.shape({
      background: PropTypes.string,
      color: PropTypes.string,
    }),
    inningStyle: PropTypes.shape({
      active: PropTypes.string,
      background: PropTypes.string,
      color: PropTypes.string,
      inactive: PropTypes.string,
    }),
    basesStyle: PropTypes.shape({
      active: PropTypes.string,
      background: PropTypes.string,
      color: PropTypes.string,
    }),
    countStyle: PropTypes.shape({
      background: PropTypes.string,
      color: PropTypes.string,
    }),
  }),
};

BaseballSimple.defaultProps = {
  data: {
    awayTeam: { name: 'Away', points: 0 },
    balls: 0,
    bases: [false, false, false],
    homeTeam: { name: 'Home', points: 0 },
    inning: { number: 1, half: 'Top' },
    outs: 0,
    strikes: 0,
  },
  styles: {
    basesStyle: {
      active: '#e6d621',
      background: '#666',
      inactive: '#fff',
    },
    countStyle: {
      background: '#444',
      color: '#fff',
    },
    inningStyle: {
      active: '#e6d621',
      background: '#333',
      color: '#fff',
      inactive: '#65602d',
    },
    points: {
      background: '#ccc',
      color: '#000',
    },
    teamName: {
      background: '#eee',
      color: '#000',
    },
  },
};

export default BaseballSimple;
